@if (infoBubble) {
    <sirius-grid>
        <sirius-info-bubble [textHtml]="infoBubble.textHtml || ''"></sirius-info-bubble>
    </sirius-grid>
}

<sirius-grid>
    @if (selectedCategory) {
        <sirius-heading
            class="header"
            data-cy="category-header"
            [h]="1"
            [text]="selectedCategory"
            textStyleCategory="display"
            textStyleSize="s">
        </sirius-heading>
    } @else {
        <sirius-heading
            class="header"
            data-cy="marketplace-header"
            [h]="1"
            [text]="marketplaceHeader"
            textStyleCategory="display"
            textStyleSize="s">
        </sirius-heading>
    }
</sirius-grid>

@if (config) {
    <sirius-card-catalogue
        [items]="config.result.items"
        [filters]="filters"
        [paging]="paging"
        [sorting]="sorting"
        [searchQuery]="searchQuery"
        [additionalQueryParams]="additionalQueryParams"
        [dataSource]="dataSource">
        @if (mappedContentCards) {
            <commerce-marketplace-categories [categories]="mappedContentCards" [selectedCategory]="selectedCategory">
            </commerce-marketplace-categories>
        }
    </sirius-card-catalogue>
}
